import React from 'react';
import { withProps } from 'recompose';

import Money from '../../../common/money';
import ToolTip from '../../../common/PortalledTooltip';

export const columns = [
  {
    Header: 'Barber name',
    accessor: 'barberName',
    id: 'barberName',
  },
  {
    Header: 'Productivity',
    accessor: 'productivity',
    id: 'productivity',
    Cell: props => `${props.value || 0}%`,
  },
  {
    Header: 'Service sales',
    accessor: 'serviceGrossTotal',
    id: 'serviceGrossTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Product sales',
    accessor: 'productGrossTotal',
    id: 'productGrossTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Gross sales',
    accessor: 'grossTotal',
    id: 'grossTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Product/Service Sales',
    accessor: 'productServiceRatio',
    id: 'productServiceRatio',
    Cell: props => props.original.serviceGrossTotal ? Number(props.value).toFixed(2) : 'N/A',
  },
  {
    Header: 'Refunds',
    accessor: 'grossRefunds',
    id: 'grossRefunds',
    Cell: props => <Money cents={props.value} />,
  },
  {
    accessor: 'grossDiscounts',
    id: 'grossDiscounts',
    Header: () => (
      <div>
        <span>Discounts</span>
        <div className="u-inline-block u-position-relative">
          <ToolTip className="u-type--no-transform" align="bottom">
            Includes discounts, promos and loyalty reward totals
          </ToolTip>
        </div>
      </div>
    ),
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Net sales',
    accessor: 'netTotal',
    id: 'netTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Tips',
    accessor: 'tips',
    id: 'tips',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Services sold',
    accessor: 'serviceQuantitySold',
    id: 'serviceQuantitySold',
  },
  {
    Header: 'Products sold',
    accessor: 'productQuantitySold',
    id: 'productQuantitySold',
  },
];

export const withDefaultColumns = withProps(() => ({ columns }));
